enum CropperFuncNamesEnum {
  crop = 'crop',
  rotate = 'rotate'
}

const formatBytes = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

const getPDFPreviewUrl = (url: string) => {
  return `${url}#toolbar=0&navpanes=0&scrollbar=0`;
}

const getFileNameFromUrl = (url: string): string => {
  try {
    const { pathname } = new URL(url);

    return decodeURIComponent(pathname.split('/').pop() || '');
  } catch {
    return decodeURIComponent((url.split('?')[0].split('/').pop()) || '');
  }
}

const DWG_EXTENSION = '.dwg';

const isCadFileName = (fileNameOrUrl: string): boolean => {
  return getFileNameFromUrl(fileNameOrUrl).toLowerCase().endsWith(DWG_EXTENSION);
};

export { CropperFuncNamesEnum, DWG_EXTENSION, formatBytes, getPDFPreviewUrl, getFileNameFromUrl, isCadFileName };
